// Dropdown Toggle
const toggleBtn = document.getElementById("offersToggle");
const offersBody = document.getElementById("offersBody");

if (toggleBtn && offersBody) {
  const arrow = toggleBtn.querySelector(".arrow");

  toggleBtn.addEventListener("click", () => {
    offersBody.classList.toggle("hide");
    if (arrow) arrow.classList.toggle("rotate");
  });
}


// Copy to Clipboard
const copyButtons = document.querySelectorAll(".copy-btn");

if (copyButtons.length > 0) {
  copyButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      const span = btn.querySelector("span");
      if (!span) return;

      const code = span.getAttribute("data-code");
      if (!code) return;

      navigator.clipboard.writeText(code);

      span.innerText = "Copied!";

      setTimeout(() => {
        span.innerText = code;
      }, 2000);
    });
  });
}